import { useMutation } from "react-query";
import { deleteUser } from "../api/user/deleteUser";

export function useMutationDeleteUser() {
  return useMutation(deleteUser);
}
